// extracted by mini-css-extract-plugin
export default {"container":"ColorPicker_container__ZRFS9","color":"ColorPicker_color__hwV0i"};